export type { LinkProps, BaseLinkProps } from './Link.types'
export { default as Link } from './Link'